<template>
  <div>
    <label class="switch">
      <input type="checkbox" :checked="checked" @change="emitValue">
      <span class="slider round"></span>
    </label>
  </div>
</template>
<script>
  export default {
    name: 'button-switch',
    props: ['reference', 'value'],
    data () {
      return {
        checked: false
      }
    },
    methods: {
      emitValue () {
        this.$emit('toggle', this.reference)
      },
      toggle (value) {
        this.checked = value
      }
    },
    mounted () {
      this.$helper.$on('toggleSwitches', this.toggle)
    },
    beforeDestroy () {
      this.$helper.$off('toggleSwitches')
    }
  }
</script>
<style>
/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

/* Hide default HTML checkbox */
.switch input {display:none;}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #5c90c4;
}

input:focus + .slider {
  box-shadow: 0 0 1px #5c90c4;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// ButtonSwitch.vue?6c790d57